import React, {Component} from "react";
import EdicionPosturaView from "./EdicionPosturaView";

const emisoras = [
    {name: 'Guber', code: 'em1'},
    {name: 'Emisora 2', code: 'em2'},
    {name: 'Emisora 3', code: 'em3'},
    {name: 'Emisora 4', code: 'em4'},
    {name: 'Emisora 5', code: 'em5'}
];

function getEmisoras() {
    return emisoras;
}


export default class EdicionPosturaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emisora: null,
            cantidad: null,
            precio: null,
            total: null,
            premio: null,
            tipoAforo: null,
            plazo: null,
            tasa: null,
            sobretasa: null,
            plazoMin: null,
            fechaValor: null,
        };
    }

    componentDidMount() {
        this.setState(
            {
                emisoras: getEmisoras()
            }
        )
    }

    handleChangeText = (event) => {
        const {name, value} = event.target
        this.setState({[name]: value});
    };

    render() {
        const {
            emisora, cantidad, precio, total,
            premio, tipoAforo, plazo, tasa,
            sobretasa, plazoMin, fechaValor, emisoras
        } = this.state

        return (
            <EdicionPosturaView emisora={emisora} cantidad={cantidad} precio={precio}
                                total={total} premio={premio} tipoAforo={tipoAforo}
                                plazo={plazo} tasa={tasa} sobretasa={sobretasa}
                                plazoMin={plazoMin} fechaValor={fechaValor}
                                emisoras={emisoras}
                                handleChangeText={this.handleChangeText}
            />
        );
    }

}